// removed by extract-text-webpack-plugin
module.exports = {"scroll":"_3-AqcS_EUhxpRh5wAfpICv","floating":"_1AiNZIIQy5VQv7kQSOyazQ","grey":"_3NTLg5aj7IBl0WMDiUiH81"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/BoxScroll/style.css
// module id = 504
// module chunks = 38